export const useLocalePath = () => {
  return (name: string) => {
    // Simple locale path function - replace with actual i18n routing if needed
    // For now, just return the route name as path
    // If you install @nuxtjs/i18n, this will be provided automatically
    
    // Map route names to paths
    const routeMap: Record<string, string> = {
      'ct.index': '/',
      'ct.login': '/login',
    }
    
    return routeMap[name] || `/${name}`
  }
}

